import { render, staticRenderFns } from "./SystemTest.vue?vue&type=template&id=0961de4c&scoped=true&"
import script from "./SystemTest.vue?vue&type=script&lang=js&"
export * from "./SystemTest.vue?vue&type=script&lang=js&"
import style0 from "./SystemTest.vue?vue&type=style&index=0&id=0961de4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0961de4c",
  null
  
)

export default component.exports